export const APP_FILE_SCHEME = "appfile";

export function toAppFileUrl(filePath: string) {
  if (!filePath) return "";
  const trimmed = filePath.trim();
  if (!trimmed) return "";
  if (trimmed.startsWith(`${APP_FILE_SCHEME}://`)) return trimmed;
  const withoutScheme = trimmed.startsWith("file://")
    ? trimmed.slice("file://".length)
    : trimmed;
  const normalized = withoutScheme.replace(/\\/g, "/");
  const withLeadingSlash = normalized.startsWith("/") ? normalized : `/${normalized}`;
  return `${APP_FILE_SCHEME}://${encodeURI(withLeadingSlash)}`;
}
